import createMarker from '@PROJECT_ROOT/assets/shared/js/map/createMarker';

export default function makeCreateBeachMarker(dependencies) {
    return createBeachMarker.bind(null, dependencies);
}

export function createBeachMarker(dependencies, beach, clickHandler) {
    const beachIconData = {
        url: dependencies.beachIconURL,
        scaledSize: new dependencies.google.maps.Size(29, 39),
    };
    const beachActiveIconData = {
        url: dependencies.beachActiveIconURL,
        scaledSize: new dependencies.google.maps.Size(29, 39),
    };

    const googleOptions = {
        map: dependencies.googleMap,
        position: {
            lat: parseFloat(beach.coordinates.latitude),
            lng: parseFloat(beach.coordinates.longitude),
        },
        icon: {
            url: dependencies.beachIconURL,
            scaledSize: new dependencies.google.maps.Size(29, 39),
        },
    };
    const customOptions = {
        iconData: beachIconData,
        activeIconData: beachActiveIconData,
    };

    const marker = createMarker(dependencies.google, googleOptions, customOptions, clickHandler);

    marker.beachId = beach.id;

    return marker;
}
